module.exports = __webpack_public_path__ + "img/04.94649a62.jpg";